import axios from 'axios'
import {Toast} from 'vant'

const service = axios.create({
  baseURL: '/property-billing', // url = base url + request url
  timeout: 10000
  // withCredentials: true // send cookies when cross-domain requests
})

// Request interceptors
service.interceptors.request.use(
  (config) => {
    // Add X-Access-Token header to every request, you can add other custom headers here
    // 登录添加token
    // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    config.headers['User-Token'] = localStorage.getItem("token");

    // 让每个请求携带小区id
    config.headers['Community-Id'] = localStorage.getItem("communityId");

    // 让每个请求携带订单号
    config.headers['Charge-Order-Id'] = localStorage.getItem("chargeOrderId");

    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  (response) => {
    // Some example codes here:
    // code == 20000: success
    // code == 50001: invalid access token
    // code == 50002: already login in other place
    // code == 50003: access token expired
    // code == 50004: invalid user (user not exist)
    // code == 50005: username or password is incorrect
    // You can change this part for your own usage.
    const res = response.data
    if (res.status !== 'OK') {
      Toast.fail(res.message || 'Error');
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return response.data
    }
  },
  (error) => {
    Toast.fail( error.message);
    return Promise.reject(error)
  }
)

export default service
